import { render, staticRenderFns } from "./expensesnote.vue?vue&type=template&id=30979003&scoped=true"
import script from "./expensesnote.vue?vue&type=script&lang=js"
export * from "./expensesnote.vue?vue&type=script&lang=js"
import style0 from "./expensesnote.vue?vue&type=style&index=0&id=30979003&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30979003",
  null
  
)

export default component.exports